// extracted by mini-css-extract-plugin
export default {"large":"Spinner__large___bUtEx","small":"Spinner__small___R2dP6","loader":"Spinner__loader___pslNE","load8":"Spinner__load8___Arfuv","center":"Spinner__center___Jrjcv"};